export interface IntegrationConfigJson {
  id: number;
  silae_auto_integration: boolean;
  silae_integration_day: number;
}

export class IntegrationConfig {
  constructor(
    public id: number,
    public silaeAutoIntegration: boolean,
    public silaeIntegrationDay: number
  ) {}

  static fromJson(json: IntegrationConfigJson): IntegrationConfig {
    return new IntegrationConfig(json.id, json.silae_auto_integration, json.silae_integration_day);
  }

  static toJson(value: IntegrationConfig): IntegrationConfigJson {
    return {
      id: value.id,
      silae_auto_integration: value.silaeAutoIntegration,
      silae_integration_day: value.silaeIntegrationDay
    };
  }
}
